import React, { useContext } from 'react';
import { Stack, IStackProps } from '@grubhubprod/gh-cookbook-react';
import { DataTableSelectionContext } from 'src/components/DataTable/components/DataTableSelectionProvider/DataTableSelectionContext';
import { DataTableSelectionActionBar } from 'src/components/DataTable/components/DataTableSelectionActionBar/DataTableSelectionActionBar';

export const DataTableContent: React.FC<IStackProps> = ({
  children,
  x = 'none',
  y = 'none',
}) => {
  const selectionContext = useContext(DataTableSelectionContext);

  return (
    <Stack x={x} y={y}>
      {selectionContext && <DataTableSelectionActionBar />}
      {children}
    </Stack>
  );
};
